import React from "react";

import { useIntl } from "react-intl";

import { LabeledSwitch } from "@app/component/input/LabeledSwitch";

interface Props {
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const AutomaticSsoSignIn: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  return (
    <LabeledSwitch
      checked={value}
      description={intl.formatMessage({
        id: "settings.organizationDetails.data.automaticSsoLogin.switch.description",
        defaultMessage:
          "Enable this setting to allow organization members to join MMC if seats are available. If no seats are open, you'll receive an email prompting you to purchase additional seats. Turning this setting off will restrict new users from signing up independently.",
        description: "Settings organization details - Data - Automatic SSO Login - description",
      })}
      onChange={onChange}
      title={intl.formatMessage({
        id: "settings.organizationDetails.data.automaticSsoLogin.switch.title",
        defaultMessage: "Automatically add SSO sign-in users to your organization",
        description: "SSO settings switch label",
      })}
    />
  );
};

export default AutomaticSsoSignIn;
